import { textHelpers } from '@/helpers/TextHelper.js'
import { get } from 'lodash'

export default {
  filters: {
    getName(member) {
      if (member) {
        const lastName = textHelpers.getLastName(get(member, 'name', ''))
        // const lastName = textHelpers.getLastName(get(member, 'username', ''))
        if (get(member, 'gender') === 'male') {
          return `T. ${lastName}`
        } else if (get(member, 'gender') === 'female') {
          return `C. ${lastName}`
        } else {
          return lastName
        }
      }
      return ''
    }
  }
}
